/**
 * 注意事项：
 * 1、window 手动实现scrollTo方法，需要同时修改document.documentElement与document.body下的scrollLeft/scrollTop值
 * 2、安卓低版本，Element.prototype.scroll 及Element.prototype.scrollTo 为undefined，自实现需要修改目标dom的scrollTop/scrollLeft
 * 3、安卓4.4，window.scroll({ left: 0, top: 500, behavior: "smooth" })不会报错，但会跳到0， 0的位置
 * 4、ios统一没有过度效果，无足够机型测试
 */
import getAndroidVersion from "../utils/getAndroidVersion";

function scroll_polyfill() {
  window_scroll_polyfill();
  element_scroll_polyfill();
}
// 执行
scroll_polyfill();

/**
 * 修改window 的scroll方法
 */
function window_scroll_polyfill() {
  const version = getAndroidVersion(navigator.userAgent);
  if (version && version.SYS === "android" && version.VC < 5) {
    window.scroll = ALScroll_window;
    window.scrollTo = ALScroll_window;
  } else {
    // 暂存原scrll方法
    const old_scroll = window.scroll;
    const old_scrollTo = window.scrollTo;

    if (old_scroll) {
      try {
        // 目前发现andriod4.4版本，该方法不会报错，但是无论无论传入什么参数，都会跳到0，0的位置
        window.scroll({ left: 0, top: 0, behavior: "smooth" });
      } catch (err) {
        window.scroll = ALScroll_window;
      }
    } else {
      window.scroll = ALScroll_window;
    }

    if (old_scrollTo) {
      try {
        window.scrollTop({ left: 0, top: 0, behavior: "smooth" });
      } catch (err) {
        window.scrollTo = ALScroll_window;
      }
    } else {
      window.scrollTo = ALScroll_window;
    }
  }
}

/**
 * 修改Element.prototype 的scroll方法
 */
function element_scroll_polyfill() {
  const version = getAndroidVersion(navigator.userAgent);
  if (version && version.SYS === "android" && version.VC < 5) {
    Element.prototype.scroll = ALScroll_element;
    Element.prototype.scrollTo = ALScroll_element;
  } else {
    // 暂存原scrll方法
    try {
      const old_scroll = Element.prototype.scroll;
      const old_scrollTo = Element.prototype.scrollTo;
      const bodyDom = document.getElementsByTagName("body")[0];

      if (old_scroll) {
        if (bodyDom) {
          try {
            bodyDom.scroll({ left: 0, top: 0, behavior: "smooth" });
          } catch (err) {
            Element.prototype.scroll = ALScroll_element;
          }
        } else {
          // eslint-disable-next-line
          console.error("can not get body");
        }
      } else {
        Element.prototype.scroll = ALScroll_element;
      }

      if (old_scrollTo) {
        if (bodyDom) {
          try {
            bodyDom.scrollTop({ left: 0, top: 0, behavior: "smooth" });
          } catch (err) {
            Element.prototype.scrollTo = ALScroll_element;
          }
        } else {
          // eslint-disable-next-line
          console.error("can not get body");
        }
      } else {
        Element.prototype.scrollTo = ALScroll_element;
      }
    } catch (err) {
      // eslint-disable-next-line
      console.error(err);
    }
  }
}

/**
 * 自实现Element.prototype.scroll, 通过修改目标的scrollTop与scrollLeft实现，无过度效果
 */
function ALScroll_element() {
  if (arguments.length === 2) {
    // target.scroll(x, y)
    if (typeof arguments[0] === "number" && typeof arguments[1] === "number") {
      this.scrollLeft = arguments[0];
      this.scrollTop = arguments[1];
    }
  } else if (arguments.length === 1 && typeof arguments[0] === "object") {
    // target.scroll({ left: x, top: y, behavior: "smooth" })
    var param = arguments[0];
    if (typeof param.left === "undefined" || typeof param.top === "undefined") {
      // eslint-disable-next-line
      console.warn("The method requires two parameters named left、top");
      return;
    }
    this.scrollLeft = param.left;
    this.scrollTop = param.top;
  }
}

/**
 * 自实现window.scroll,
 * 通过修改目前的scrollTop与scrollLeft实现，无过度效果
 * 不通浏览器原理不同
 * 统一将documentElement和body上的值都改了
 */
function ALScroll_window() {
  if (arguments.length === 2) {
    // target.scroll(x, y)
    if (typeof arguments[0] === "number" && typeof arguments[1] === "number") {
      document.documentElement.scrollLeft = arguments[0];
      document.body.scrollLeft = arguments[0];
      document.documentElement.scrollTop = arguments[1];
      document.body.scrollTop = arguments[1];
    }
  } else if (arguments.length === 1 && typeof arguments[0] === "object") {
    // target.scroll({ left: x, top: y, behavior: "smooth" })
    var param = arguments[0];
    if (typeof param.left === "undefined" || typeof param.top === "undefined") {
      // eslint-disable-next-line
      console.warn("The method requires two parameters named left、top");
      return;
    }
    document.documentElement.scrollLeft = param.left;
    document.body.scrollLeft = param.left;
    document.documentElement.scrollTop = param.top;
    document.body.scrollTop = param.top;
  }
}
